// Priority is a simple yes/no flag (Task #461). This control renders either
// an expanded Yes/No segmented toggle (modal forms) or a compact inline
// toggle button (topic rows) for quick editing.
interface Props {
  value: boolean
  onChange: (priority: boolean) => void
  expanded?: boolean
}

export default function PriorityDropdown({ value, onChange, expanded }: Props) {
  if (expanded) {
    return (
      <div className="flex items-center gap-1 bg-[#F5F5F5] p-1 rounded-lg w-fit">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
            value ? 'bg-white shadow-sm text-text-primary' : 'text-text-secondary hover:text-text-primary'
          }`}
        >
          Yes
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
            !value ? 'bg-white shadow-sm text-text-primary' : 'text-text-secondary hover:text-text-primary'
          }`}
        >
          No
        </button>
      </div>
    )
  }

  return (
    <button
      type="button"
      onClick={() => onChange(!value)}
      title={value ? 'Priority — click to unset' : 'Not a priority — click to set'}
      className={`px-2 py-0.5 rounded font-bold uppercase tracking-wider transition-colors ${
        value
          ? 'bg-[#ED1C24]/10 text-[#ED1C24] hover:bg-[#ED1C24]/20'
          : 'text-text-muted hover:bg-stone/20'
      }`}
      style={{ fontSize: '11px' }}
    >
      {value ? 'Priority' : 'Set priority'}
    </button>
  )
}
